import { render, staticRenderFns } from "./venues.vue?vue&type=template&id=2671fc07&"
import script from "./venues.vue?vue&type=script&lang=js&"
export * from "./venues.vue?vue&type=script&lang=js&"
import style0 from "./venues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports